import React from "react"
import {ButtonContainer} from "../../components"
import {Cotton22OpenFiltersButton} from "./components"
import FadeInAnimation from "../../../fadeInAnimation"
import CollaspedFilter from "../../../collaspedFilter"
import CollaspedPriceFilter from "../../../collaspedPriceFilter"

interface Cotton22OpenFilterButtonProps {
    isFilterSelected?: boolean
    handleOpenFilterBtnClick: () => void
    isFilteredPrice: boolean
    filteredFacets: {[key: string]: string[]}
    text: string
    top: number
    $height: number
}
const Cotton22OpenFilterButton = ({
    top,
    $height,
    handleOpenFilterBtnClick,
    text,
    filteredFacets,
    isFilterSelected,
    isFilteredPrice,
}: Cotton22OpenFilterButtonProps) => {
    return (
        <FadeInAnimation timeout={300} show>
            <ButtonContainer
                onClick={handleOpenFilterBtnClick}
                data-testid="plp-facets-collapsed-container"
                top={top}
                $height={$height}
            >
                <Cotton22OpenFiltersButton
                    data-testid="plp-facets-open-filters-btn"
                    data-template="Cotton22"
                    onClick={handleOpenFilterBtnClick}
                    disableRipple
                >
                    {text}
                </Cotton22OpenFiltersButton>
                {isFilterSelected && <CollaspedFilter filteredFacets={filteredFacets} />}
                {isFilteredPrice && <CollaspedPriceFilter />}
            </ButtonContainer>
        </FadeInAnimation>
    )
}

export default Cotton22OpenFilterButton
